import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';

import Link from '../../Link/Link';

import messages from '../../../locale/messages';
import showToaster from '../../../helpers/showToaster';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import { censorEmail, censorPhone } from '../../../helpers/secureEmail';
import { decode } from '../../../helpers/queryEncryption';

import s from './ViewInquiry.css';
import bt from '../../../components/commonStyle.css';

class ViewInquiry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isRestrict: false
        }
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode();
        this.setState({ isRestrict });
    }

    takeAction = async (threadItemId, threadId) => {
        const { refetch } = this.props;
        let query = `query checkThreadData($threadId:Int){
            checkThreadData(threadId:$threadId){
                status
            }
        }`;

        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query,
                variables: { threadId },
            }),
            credentials: 'include',
        });

        const { data } = await resp.json();
        if (data?.checkThreadData?.status == '200') {
            return true
        } else {
            showToaster({ messageId: 'approved', toasterType: 'error' })
            let variables = {
                id: threadItemId
            };
            await refetch(variables)
            return false
        }
    }

    render() {
        const { data } = this.props;
        const { isRestrict } = this.state;

        return (
            <div>
                <h1 className={s.siteAdminHeading}><FormattedMessage {...messages.inquiryDetails} /></h1>
                <div className={cx(s.space4, bt.textAlignRight, 'textAlignLeftRtl')}>
                    <Link to={'/siteadmin/inquiry'} className={cx(bt.btnPrimaryBorder, bt.btnLarge, bt.noTextDecoration)}>
                        <FormattedMessage {...messages.goBack} />
                    </Link>
                </div>
                <div className={s.profileViewMain}>
                    {
                        data?.id && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.bookingStatus} />   </span>
                            <span className={cx(s.profileViewMainContent)}>
                                {
                                    data?.data == "preApproved" ? < FormattedMessage {...messages.messageStatus2} /> : <FormattedMessage {...messages.panelInquiry} />
                                }
                            </span>
                        </div>
                    }
                    {
                        data?.threadsData?.listData?.title && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.adminListTitle} />   </span>
                            <span className={cx(s.profileViewMainContent)}>  <a href={"/rooms/" + data.threadsData.listId} target="_blank"> {data.threadsData.listData.title} </a> </span>
                        </div>
                    }
                    {
                        data?.startDate && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.checkIn} />   </span>
                            <span className={cx(s.profileViewMainContent)}>  {moment(parseInt(data?.startDate)).format('DD MMMM YYYY')}  </span>
                        </div>
                    }
                    {
                        data?.endDate && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.checkOut} />   </span>
                            <span className={cx(s.profileViewMainContent)}>  {moment(parseInt(data?.endDate)).format('DD MMMM YYYY')}  </span>
                        </div>
                    }
                    {
                        data?.threadsData?.guestProfile?.displayName && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.guestName} />   </span>
                            <span className={cx(s.profileViewMainContent)}> <a href={"/users/show/" + data.threadsData.guestProfile.profileId} target="_blank"> {data.threadsData.guestProfile.displayName} </a>  </span>
                        </div>
                    }
                    {
                        data?.threadsData?.guestProfile?.encodePhoneNumber && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.guestPhoneNumber} />   </span>
                            <span className={cx(s.profileViewMainContent)}>  {data?.threadsData?.guestProfile?.countryCode}{' '}
                                {!isRestrict ? decode(data.threadsData.guestProfile.encodePhoneNumber) : censorPhone(decode(data.threadsData.guestProfile.encodePhoneNumber))}
                            </span>
                        </div>
                    }
                    {
                        data?.threadsData?.guestUserData?.encryptEmail && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.guestEmail} />   </span>
                            <span className={cx(s.profileViewMainContent)}>  {!isRestrict ? decode(data?.threadsData?.guestUserData?.encryptEmail) : censorEmail(decode(data?.threadsData?.guestUserData?.encryptEmail))}  </span>
                        </div>
                    }
                    {
                        data?.threadsData?.hostProfile?.displayName && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.hostNameLabel} />   </span>
                            <span className={cx(s.profileViewMainContent)}> <a href={"/users/show/" + data.threadsData.hostProfile.profileId} target="_blank"> {data.threadsData.hostProfile.displayName}  </a> </span>
                        </div>
                    }
                    {
                        data?.threadsData?.hostProfile?.encodePhoneNumber && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.hostPhoneNumber} />   </span>
                            <span className={cx(s.profileViewMainContent)}>
                                {data?.threadsData?.hostProfile?.countryCode}{' '}
                                {!isRestrict ? decode(data.threadsData.hostProfile.encodePhoneNumber) : censorPhone(decode(data.threadsData.hostProfile.encodePhoneNumber))}
                            </span>
                        </div>
                    }
                    {
                        data?.threadsData?.hostUserData?.encryptEmail && <div className={s.profileViewInner}>
                            <span className={cx(s.labelTextNew, s.profileViewlabel)}>  <FormattedMessage {...messages.hostEmail} />   </span>
                            <span className={cx(s.profileViewMainContent)}>  {!isRestrict ? decode(data?.threadsData?.hostUserData?.encryptEmail) : censorEmail(decode(data?.threadsData?.hostUserData?.encryptEmail))} </span>
                        </div>
                    }
                </div>
            </div>
        );
    }

}
const mapState = (state) => ({});

const mapDispatch = {
    demoRestrictionEncode
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ViewInquiry)));